import { useSelector } from 'react-redux'
import authPersistSelectors from '../store/selectors/auth.persist.selectors'
import userSelectors from '../store/selectors/user.selectors'

export const useIsSenseUserOrImpersonated = () => {
    const isImpersonated = useSelector(authPersistSelectors.isImpersonated)

    const isSenseUser = useSelector(userSelectors.isSenseUser)

    return isImpersonated || isSenseUser
}
